const TYPE_VIDEO = 'video';

export function isVideo(multimediaType) {
  return multimediaType === TYPE_VIDEO;
}

export function getYouTubeVideoId(videoUrl = '') {
  videoUrl = videoUrl || '';
  return videoUrl.match(
    /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|e\/|v\/|vi\/|watch\?v=|watch\?vi=|watch\?.+&v=|watch\?.+&vi=|\?v=|\?vi=))((\w|-){11})(?:\S+)?$/
  )
    ? RegExp.$1
    : null;
}

export function getYouTubeStill(videoUrl) {
  return `https://img.youtube.com/vi/${getYouTubeVideoId(videoUrl)}/0.jpg`;
}

export function appendParamsInYoutubeURL() {
  // Get all iframes
  const frames = document.getElementsByTagName('iframe');
  // Loop through each iframe in the page
  for (let i = 0; i < frames.length; i++) {
    // Check for YouTube embed iframes
    if (
      frames[i].src &&
      frames[i].src.length > 0 &&
      frames[i].src.match(/http(s)?:\/\/(www\.)?(youtube\.com|youtu\.be)/)
    ) {
      // Extract src and video ID using regex
      const src = frames[i].src;
      const p =
        /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      const matchResult = src.match(p);
      const id = matchResult && matchResult[1] ? matchResult[1] : false;
      if (!id) {
        continue;
      }
      // Append parameters to the src URL
      const newSrc = `${src.split('?')[0]}?loop=1&playlist=${id}&rel=0`;
      frames[i].src = newSrc;
    }
  }
}

export default { isVideo, getYouTubeStill, getYouTubeVideoId, appendParamsInYoutubeURL };
